var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconeAdicionarCliente(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00033 0.166504C6.36852 0.166504 6.66699 0.464981 6.66699 0.833171V4.83317H10.667C11.0352 4.83317 11.3337 5.13165 11.3337 5.49984C11.3337 5.86803 11.0352 6.16651 10.667 6.16651H6.66699V10.1665C6.66699 10.5347 6.36852 10.8332 6.00033 10.8332C5.63214 10.8332 5.33366 10.5347 5.33366 10.1665V6.16651H1.33366C0.965469 6.16651 0.666992 5.86803 0.666992 5.49984C0.666992 5.13165 0.965469 4.83317 1.33366 4.83317H5.33366V0.833171C5.33366 0.464981 5.63214 0.166504 6.00033 0.166504Z",
    fill: "#F8F8F9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeAdicionarCliente);
export default __webpack_public_path__ + "static/media/icone-adicionar-cliente.cc857320dff4f2ad727525f083ee46c6.svg";
export { ForwardRef as ReactComponent };